import Flickity from 'flickity';
import layout from '../Layout';
import getHeaderOffset from '../helpers/getHeaderOffset';

export default class StaticSlideshow {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;

    this.carousel = this.el.querySelector('.slideshow');
    this.slides = '.slideshow-slide';
    this.container = this.el.querySelector('.slideshow-height-fullscreen')
    this.isFullscreen = !!this.container;
    this.selectBlockOnLoad = true;
    this.continueAutoplay = true;
    this.stopAutoplay = false;
    this.autoplayTimeout = 0;

    this.flickity = null;
    this.flickityOptions = null;

    if (this.carousel && this.carousel.querySelectorAll(this.slides).length > 1) {
      this._initSlider();
    }
  }

  _initSlider() {
    this.flickityOptions = {
      autoPlay: this.settings.enable_autoplay ? this.settings.autoplay_duration * 1000 : false,
      setGallerySize: !this.isFullscreen,
      pauseAutoPlayOnHover: false,
      accessibility: true,
      adaptiveHeight: true,
      cellAlign: 'left',
      cellSelector: this.slides,
      imagesLoaded: true,
      contain: true,
      wrapAround: true,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    };

    this._bindFlickity();
  }

  _bindEvents() {
    this._slideshowHeight();
    this._positionDots();
    this._changeArrrowColors();

    window.addEventListener('resize', () => {
      this._slideshowHeight();
      this._positionDots();
      this._changeArrrowColors();
    });

    this.flickity.on('select', () => {
      this._slideshowHeight();
      this._positionDots();
      this._changeArrrowColors();

      this.selectBlockOnLoad = false;

      if (this.settings.enable_autoplay && !this.stopAutoplay) {
        this.flickity.pausePlayer();

        if (this.continueAutoplay) {
          this.autoplayTimeout = 0;
        } else {
          this.autoplayTimeout = 10000;
        }

        this.continueAutoplay = true;

        setTimeout(() => {
          this.flickity.playPlayer();
        }, this.autoplayTimeout);
      }
    });

    this.flickity.on('dragStart', () => {
      this.continueAutoplay = false;
    });
  }

  _positionDots() {
    const pageDots = this.el.querySelector('.flickity-page-dots');

    if (layout.isBreakpoint('XS') && !this.isFullscreen) {
      const height = this.flickity.selectedElement.querySelector('.slideshow-background').offsetHeight;
      const gutterContent = 5;

      pageDots.style.top = `${height + gutterContent}px`;
    } else {
      pageDots.style.top = 'auto';
    }
  }

  _changeArrrowColors() {
    let currentColor = this.flickity.selectedElement.querySelector('.slideshow-background').dataset;
    const dots = this.el.querySelectorAll('.flickity-page-dots .dot');

    if (layout.isBreakpoint('XS') && !this.isFullscreen) {
      currentColor = currentColor.themecolor;
    } else {
      currentColor = currentColor.slidecolor;
    }

    this.el.querySelector('.flickity-prev-next-button.previous svg').style.fill = currentColor;
    this.el.querySelector('.flickity-prev-next-button.next svg').style.fill = currentColor;

    for (let i = 0; i < dots.length; i++) {
      dots[i].style.background = currentColor;
    }
  }

  _slideshowHeight() {
    const headerHeight = getHeaderOffset(document.querySelector('.site-header-wrapper'));

    if (this.isFullscreen) {
      this.el.querySelector('.flickity-viewport').style.height = `calc(100vh - ${headerHeight}px)`;
      this.container.style.height = `calc(100vh - ${headerHeight}px)`;
    }
  }

  onSectionUnload() {
    this._destroyFlickity();
  }

  _bindFlickity() {
    this.flickity = new Flickity(this.carousel, this.flickityOptions);
    this._bindEvents();
  }

  _destroyFlickity() {
    if (!this.flickity) {
      return;
    }

    this.flickity.destroy();
  }

  onSectionBlockSelect(block) {
    setTimeout(() => {
      this.flickity.resize();
    }, 100);

    if (this.settings.enable_autoplay) {
      const $slides = $(this.slides);
      const $slide = $(block.el);
      const slideIndex = $slides.index($slide);

      this.stopAutoplay = true;
      this.flickity.pausePlayer();

      if (!$slide.hasClass('is-selected') && !this.selectBlockOnLoad) {
        this.flickity.select(slideIndex, false, false);
      } else if (this.selectBlockOnLoad) {
        this.flickity.select(slideIndex, false, true);
      }
    }
  }

  onSectionBlockDeselect() {
    if (this.settings.enable_autoplay) {
      this.stopAutoplay = false;
      this.flickity.playPlayer();
    }
  }
}
